var React = require('react');

function LetterX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.45 2.67a1.593 1.593 0 010-2.22 1.594 1.594 0 012.22 0l13.322 13.341L29.337.45a1.5627 1.5627 0 012.2 2.22L18.212 15.99l13.322 13.341a1.5627 1.5627 0 01-2.2 2.22L15.992 18.209 2.67 31.55a1.594 1.594 0 01-2.22 0 1.593 1.593 0 010-2.22l13.322-13.34z","fill":"#fff"}));
}

LetterX.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = LetterX;

LetterX.default = LetterX;
